import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-email-template",
  templateUrl: "./email-template.component.html",
  styleUrls: ["./email-template.component.scss"],
})
export class EmailTemplateComponent {
  @Input() visible = false;
  @Output() onClose = new EventEmitter<void>();
  onCancel(): void {
    this.onClose.emit();
  }
}
